// libraries
import StackIcon from 'tech-stack-icons'

// local
import Me from './partials/Me'
import Languages from './partials/Languages'
import Tools from './partials/Tools'
import Certifications from './partials/Certifications'


export default function App() {


  return (
    <div>
      <div
        className="w-screen h-screen flex items-center justify-center"
        style={{
          backgroundImage: "url('sfondo.jpg')"
        }}
      >
        <div className="flex flex-col gap-6 p-8 rounded-xl bg-white shadow-lg">
          <Me />

          {/* stack */}
          <div className="flex flex-row gap-4 items-center justify-end mt-6">
            <StackIcon name="ubuntu" className="w-8" />
            <StackIcon name="vscode" className="w-8" />
            <StackIcon name="tailwindcss" className="w-8" />
            <StackIcon name="openai" className="w-8" />
          </div>
        </div>
      </div>
      <div className="container mx-auto my-16">
        <Languages />
      </div>
      <div className="container mx-auto my-16">
        <Tools />
      </div>
      <div className="container mx-auto my-16">
        <Certifications />
      </div>
    </div>
  )
}